module.exports = __webpack_public_path__ + "assets/media/view_icon.34e1cf0f.svg";